import apiClient from './apiClient';

export const topicService = {
  async getAllTopics() {
    try {
      const response = await apiClient.get('/topics');
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load topics');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load topics. Please try again.');
    }
  },

  async getTopicById(topicId) {
    try {
      const response = await apiClient.get(`/topics/${topicId}`);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load topic');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load topic. Please try again.');
    }
  },

  async createTopic(topicData) {
    try {
      const response = await apiClient.post('/topics', topicData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to create topic');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to create topic. Please try again.');
    }
  },

  async updateTopic(topicId, topicData) {
    try {
      const response = await apiClient.put(`/topics/${topicId}`, topicData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to update topic');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update topic. Please try again.');
    }
  },

  async deleteTopic(topicId) {
    try {
      const response = await apiClient.delete(`/topics/${topicId}`);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to delete topic');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to delete topic. Please try again.');
    }
  },

  async updateTopicOrder(topicIds) {
    try {
      const response = await apiClient.put('/topics/order', topicIds);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to update topic order');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update topic order. Please try again.');
    }
  },

  // Question methods
  async getQuestionsByTopicId(topicId) {
    try {
      const response = await apiClient.get(`/questions/topic/${topicId}`);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load questions');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load questions. Please try again.');
    }
  },

  async getQuestionsBySubjectId(subjectId) {
    try {
      const response = await apiClient.get(`/questions/subject/${subjectId}`);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load questions');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load questions. Please try again.');
    }
  },

  async addQuestion(topicId, questionData) {
    try {
      const response = await apiClient.post(`/questions/topic/${topicId}`, questionData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to add question');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to add question. Please try again.');
    }
  },

  async updateQuestion(questionId, questionData) {
    try {
      const response = await apiClient.put(`/questions/${questionId}`, questionData);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to update question');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update question. Please try again.');
    }
  },

  async updateQuestionAttempts(questionId, lastAttempts) {
    try {
      const response = await apiClient.post(`/questions/${questionId}/attempt`, { attempts: lastAttempts });
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to update question attempts');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update question attempts. Please try again.');
    }
  },

  async deleteQuestion(questionId) {
    try {
      const response = await apiClient.delete(`/questions/${questionId}`);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to delete question');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to delete question. Please try again.');
    }
  },

  async updateQuestionOrder(topicId, questionIds) {
    try {
      const response = await apiClient.put(`/questions/topic/${topicId}/order`, questionIds);
      
      if (response.data.result !== 'SUCCESS') {
        throw new Error(response.data.message || 'Failed to update question order');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update question order. Please try again.');
    }
  },

  async getTopicsBySubjectId(subjectId) {
    try {
      const response = await apiClient.get(`/topics/subject/${subjectId}`);
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to load topics');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to load topics. Please try again.');
    }
  },
}; 